import React from 'react';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

import { textInputStyle } from '../themes/input';

const styles = (theme) => ({
  ...textInputStyle(theme),
  buttonWrapper: {},
  button: {
    display: 'inline-flex',
    justifyContent: 'center',
    fontWeight: 800,
    padding: '7px 16px',
  },
  buttonLoading: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
});

const MHButton = ({
  classes,
  wrapperWidth,
  buttonWrapperExtraClasses = [],
  extraClasses = [],
  onClick,
  disabled,
  loading,
  loadingSize = 24,
  children,
  variant = 'contained',
  ...props
}) => (
  <div
    className={classNames(classes.buttonWrapper, ...buttonWrapperExtraClasses)}
    style={wrapperWidth ? { width: wrapperWidth } : {}}
  >
    <Button
      variant={variant}
      color="primary"
      disabled={disabled}
      className={classNames(classes.button, ...extraClasses)}
      onClick={onClick}
      {...props}
    >
      {children}
    </Button>
    {loading && <CircularProgress size={loadingSize} className={classes.buttonLoading} />}
  </div>
);

export default withStyles(styles)(MHButton);
